import BenefitsApi from '@/api/BenefitsApi';
import _ from 'lodash';
import Segment from '@/Segment';

const BENEFIT_TYPES = {
  FREE_MONTHS: 'free-months',
  SECOND_MONTH_FREE: 'second-month-free',
};

const state = {
  benefitId: null,
  benefitType: null,
  benefitAmount: null,
  benefitPromotion: null,
};

const getters = {
  BENEFIT_TYPES: state => BENEFIT_TYPES,
};

const actions = {
  async initBenefits({ commit }) {
    const benefits = await BenefitsApi.getEligibleBenefits();
    if (!_.isEmpty(benefits)) {
      commit('setBenefitId', benefits[0]._id);
      commit('setBenefitType', benefits[0].benefitType);
      commit('setBenefitAmount', benefits[0].benefitAmount);
      commit('setBenefitPromotion', benefits[0].promotion);
    }
  },
  async redeemBenefit({ state }) {
    await BenefitsApi.redeemBenefit(state.benefitId);
    Segment.trackUserGot('BenefitRedeemed', { benefitType: state.benefitType, benefitAmount: state.benefitAmount });
  },
  async createBenefit({ dispatch }, promotion) {
    await BenefitsApi.createBenefit(promotion);
    await dispatch('initBenefits');
  },
};

const mutations = {
  setBenefitId(state, benefitId) {
    state.benefitId = benefitId;
  },
  setBenefitType(state, benefitType) {
    state.benefitType = benefitType;
  },
  setBenefitAmount(state, benefitAmount) {
    state.benefitAmount = benefitAmount;
  },
  setBenefitPromotion(state, benefitPromotion) {
    state.benefitPromotion = benefitPromotion;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
